import { render, staticRenderFns } from "./FooterDRL.vue?vue&type=template&id=27132174&scoped=true"
import script from "./FooterDRL.vue?vue&type=script&lang=js"
export * from "./FooterDRL.vue?vue&type=script&lang=js"
import style0 from "./FooterDRL.vue?vue&type=style&index=0&id=27132174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27132174",
  null
  
)

export default component.exports